import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import { Claim2CustomerI} from '../../../../interfaces/claim.interface';
import {HttpErrorResponse} from "@angular/common/http";
import {AppService} from "../../../../services/app.service";


@Component({
  selector: 'app-c2c-edit',
  templateUrl: './c2c-edit.component.html',
  styleUrls: ['./c2c-edit.component.scss']
})
export class C2cEditComponent implements OnInit {

  constructor(private app: AppService, @Inject(MAT_DIALOG_DATA) public data: Claim2CustomerI) { }

  ngOnInit(): void {
    console.log(this.data)
  }

  resendInvitation() {
    const data = {claimName: this.data.claim_name, c2c_id: this.data.id};
    this.app.sendActivationMail(data).then(res => {
      console.log(res);
      this.app.dialog.closeLoader();
      this.app.toast.open('Die E-Mail wurde erfolgreich gesendet.');
    }).catch((e: HttpErrorResponse) => {
      console.error(e);
      this.app.dialog.closeLoader();
      let msg = 'Unbekannter Fehler';
      this.app.toast.open(msg, null, {
        panelClass: 'warn'
      });
    });
  }

}
